// No lookbehind for the "+" in front: Safari before 16.4 cannot parse one,
// and a regex literal it cannot parse fails the whole bundle. findUrls checks
// the character before instead.
export const URL_RE =
  /(https?:\/\/(?:www\.)?(?:[-\p{Letter}\d.]+?[.@][a-zA-Z\d]{2,}|localhost|\[[0-9a-fA-F:]+(?:\.[0-9]{1,3}){0,4}\])(?:[-\w\p{Letter}.:%+~#*$!?&/=@]*?(?:,(?!\s))*?)*)/gu;

export function* findUrls(str: string) {
  const re = new RegExp(URL_RE);
  for (let match; (match = re.exec(str));) {
    // Not after a "+". Retry from the next character, as a lookbehind would.
    if (str[match.index - 1] === '+') re.lastIndex = match.index + 1;
    else yield match;
  }
}

export function renderLinks(el: HTMLElement) {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  const texts: Text[] = [];
  while (walker.nextNode()) texts.push(walker.currentNode as Text);
  for (const node of texts) {
    // Text that is already a link stays as it is, or the anchors nest.
    if (node.parentElement?.closest('a')) continue;
    const str = node.nodeValue ?? '';
    let modified = false;
    const frag = document.createDocumentFragment();
    let lastIndex = 0;
    for (const match of findUrls(str)) {
      let url = match[0];
      const punctuation = /[.?]$/.exec(url)?.[0] ?? '';
      if (punctuation) url = url.slice(0, -1);
      if (!url) continue;
      const index = match.index ?? 0;
      const before = str.slice(lastIndex, index);
      if (before) frag.append(before);

      try {
        const parsed = new URL(url);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
          frag.append(url);
          lastIndex = index + url.length;
          continue;
        }
        const a = document.createElement('a');
        a.href = parsed.href;
        a.target = '_blank';
        a.rel = 'nofollow noopener noreferrer';
        a.textContent = url;
        frag.append(a);
        modified = true;
        lastIndex = index + url.length;
      } catch {
        frag.append(url);
        lastIndex = index + url.length;
      }
    }
    const after = str.slice(lastIndex);
    if (after) frag.append(after);
    if (modified) node.replaceWith(frag);
  }
}
